import React, { useEffect, useState, useRef } from 'react';
import useWindowSize from '../../../../hooks/useWindowSize';

import { connect } from 'react-redux';

import { Link, withRouter } from 'react-router-dom';

import { cloneDeep, isEmpty, startCase, orderBy } from 'lodash';

import ClientContextMenu from './ClientContextMenu';
import BobLoadingMask from '../../../../components/BobLoadingMask';
import DeleteCoreEntityModal from '../../Modals/DeleteCoreEntityModal';
import ColumnFilterMenu from '../../../../components/ColumnFilterMenu';
import FilterPanel from '../../../../components/K2AFilterControl/FilterPanel';

import {
    Grid,
    GridNoRecords,
    GridToolbar,
    GridColumn as Column,
} from '@progress/kendo-react-grid';
import { process as kendoProcess } from '@progress/kendo-data-query';
import { Operators, TextFilter, NumericFilter, DateFilter, BooleanFilter } from '@progress/kendo-react-data-tools';

import { calculateMinColumnWidths } from '../../../../helpers/calculateMinColumnWidths';
import { kendoGridInlineStyling } from '../../../../helpers/kendoGridInlineStyleHelper';

import queryString from 'query-string';

import * as K2ACoreActions from '../../../../actions/k2aCoreActions';
import * as TableActions from '../../../../actions/tableActions';
import * as BobActions from '../../../../actions/bobActions';
import * as ConfigurationActions from '../../../../actions/configurationActions';

import * as classes from '../EntitiesPage.module.css';

const initialDataState = {
    sort: [],
    take: 10,
    skip: 0
};

const initialDataStateFilter = {
    logic:   'and',
    filters: []
};

const CoreClientTable = ({
    activeNavCompany,
    bobLoading,
    clients,
    clientsMeta,
    configurations,
    currentUser,
    customAttributes,
    deleteCoreClient,
    fetchCoreClients,
    fetchNavSites,
    history,
    refreshTab,
    saveConfiguration,
    setRefreshTab,
    searchTerm,
    setCoreClient,
    setActiveNavClient,
    setNavClient,
    tableProps,
    updateAllConfigurations,
    updateCoreConfigurations,
    updateConfiguration,
    updateTableProps,
    userId,
    view,
    workbookModeEnabled,
    ...props
}) => {

    const [dataState, setDataState] = useState(initialDataState);
    const [deleteClientModalOpen, setDeleteClientModalOpen] = useState(false);
    const [selectedClient, setSelectedClient] = useState({});
    const [pageable] = useState({ pageSizes: true });
    const [selectedClients, setSelectedClients] = useState([]);
    const [clientNameColumnWidth, setClientNameColumnWidth] = useState(450);
    const [take, setTake] = useState(10);
    const [hasInitialized, setHasInitialized] = useState(false);
    const [gridFilterText, setGridFilterText] = useState('');
    const [gridFields, setGridFields] = useState([]);
    const [gridFilter, setGridFilter] = useState(initialDataStateFilter);

    const gridDivRef = useRef(null);
    const gridRef = useRef(null);

    const windowSize = useWindowSize();


    const defaultColumns = [
        {
            field:      'name',
            title:      'Client',
            filter:     'text',
            id:         'clientColumn',
            width:      450,
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 0,
            primaryKey: true
        },
        {
            field:      'businessType.name',
            title:      'Business Type',
            filter:     'text',
            width:      350,
            id:         'businessType',
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 1
        },
        {
            field:      'address.formattedAddress',
            title:      'Address',
            filter:     'text',
            width:      300,
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 2
        },
        {
            field:      'address.locality',
            title:      'City',
            filter:     'text',
            width:      200,
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 3
        },
        {
            field:      'address.administrativeAreaLevel1',
            title:      'State',
            filter:     'text',
            width:      150,
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 4
        },
        {
            field:      'address.postalCode',
            title:      'Zip',
            filter:     'text',
            width:      150,
            sortable:   true,
            filterable: true,
            show:       true,
            hidden:     false,
            orderIndex: 5
        },
        {
            field:      '',
            title:      '',
            width:      80,
            locked:     true,
            sortable:   false,
            filterable: false,
            show:       true,
            hidden:     true,
            actionCell: true,
            orderIndex: 1000
        }
    ];
    const [columns, setColumns] = useState(defaultColumns);
    useEffect(() => {
        let columnList = [];
        const tableConfiguration = configurations.find(item => item.viewKey === 'K2ACore|ClientTable');
        const configObject = { ...tableConfiguration };
        if (!isEmpty(tableConfiguration)) {
            if (!isEmpty(configObject.viewData.dataState.columns)) {
                columnList = [...configObject.viewData.dataState.columns];
            } else {
                let updatedColumns = [...columns];
                if (!isEmpty(customAttributes)) {
                    const selectedAttributes = customAttributes['Client'];
                    selectedAttributes.forEach(item => {
                        const attrColumn = columnList.find(c => c.field === item.name);
                        if (!attrColumn) {
                            updatedColumns.splice(1, 0, {
                                field:      item.name,
                                title:      startCase(item.name),
                                width:      200,
                                locked:     false,
                                sortable:   true,
                                filterable: true,
                                filter:     item.dataType || 'text',
                                show:       false,
                                hidden:     false,
                                orderIndex: updatedColumns.length - 1
                            });
                        }
                    });
                }
    
                columnList = [...updatedColumns];
            }
        }
        else {
            let updatedColumns = [...columns];
            if (!isEmpty(customAttributes)) {
                const selectedAttributes = customAttributes['Client'];
                selectedAttributes.forEach(item => {
                    const attrColumn = columnList.find(c => c.field === item.name);
                    if (!attrColumn) {
                        updatedColumns.splice(1, 0, {
                            field:      item.name,
                            title:      startCase(item.name),
                            width:      200,
                            locked:     false,
                            sortable:   true,
                            filterable: true,
                            filter:     item.dataType || 'text',
                            show:       false,
                            hidden:     false,
                            orderIndex: updatedColumns.length - 1
                        });
                    }
                });
            }

            columnList = [...updatedColumns];
        }

        const columnArray = columnList.map((c) => {
            c.width = c.field === 'name' ? 450 : c.width;
            return c;
        });
        const colWidth = calculateMinColumnWidths(columnArray.filter(c => c.show), gridDivRef.current.offsetWidth, 'name', 450, true);
        setClientNameColumnWidth(colWidth);
        columnArray.find(c => c.id === 'clientColumn').width = colWidth;
        setColumns(columnArray);  
    }, [windowSize]);

    useEffect(() => {
        setDataState({ ...dataState, filter: gridFilter });
    }, [gridFilter]);

    useEffect(() => {
        const columnList = orderBy(columns, 'orderIndex', 'asc').filter(col => !col.actionCell && !col.hidden).map(column => {
            const filterType = column.filter === 'text' ? TextFilter : column.filter === 'numeric' ? NumericFilter : column.filter === 'date' ? DateFilter : BooleanFilter;
            const operatorList = column.filter === 'text' ? Operators.text : column.filter === 'numeric' ? Operators.numeric : column.filter === 'date' ? Operators.date : Operators.boolean;
            return {
                name:       column.field,
                label:      column.title ? column.title : column.name,
                filter:     filterType,
                operators:  operatorList,
                actionCell: column.actionCell
            };
        });

        setGridFields(columnList);

    }, [columns]);

    useEffect(() => {
        const tableConfiguration = configurations.find(item => item.viewKey === 'K2ACore|ClientTable');

        const init = async () => {
            if (tableConfiguration) {
                if (dataState === tableConfiguration.viewData.dataState) return;
                dataState.columns = columns;
                tableConfiguration.viewData = JSON.stringify({ 
                    dataState, 
                    ownerId: currentUser.id
                });
                await updateConfiguration(tableConfiguration.id, tableConfiguration, true);
                updateCoreConfigurations(tableConfiguration.id, tableConfiguration);
            } else {
                const data = { dataState: { ...dataState, columns: columns}, ownerId: currentUser.id };

                let body = {
                    name:         'K2A Core Client Table Configuration',
                    viewKey:      'K2ACore|ClientTable',
                    entityId:     activeNavCompany.id,
                    entityName:   activeNavCompany.name,
                    isDefault:    false,
                    viewData:     JSON.stringify(data),
                    sharedEmails: []
                };

                const id = await saveConfiguration(userId, body, true);

                if (id) {
                    body.id = id;
                    let activeState = cloneDeep(body.viewData);
                    body.viewData = JSON.parse(activeState);
                    updateCoreConfigurations(id, body);
                }
            }
        };

        if (dataState && !isEmpty(configurations) && dataState !== initialDataState) {
            init();
        }
    }, [dataState]);

    useEffect(() => {
        if (!isEmpty(configurations) && !hasInitialized) {
            const tableConfiguration = configurations.find(item => item.viewKey === 'K2ACore|ClientTable');

            if (!isEmpty(tableConfiguration)) {
                setDataState(tableConfiguration.viewData.dataState);

                if (tableConfiguration.viewData.dataState.columns) {
                    const columnArray = tableConfiguration.viewData.dataState.columns.map((c) => {
                        c.width = c.field === 'name' ? 450 : c.width;
                        return c;
                    });
                    const colWidth = calculateMinColumnWidths(columnArray.filter(c => c.show), gridDivRef.current.offsetWidth, 'name', 450, true);
                    setClientNameColumnWidth(colWidth);
                    columnArray.find(c => c.id === 'clientColumn').width = colWidth;
                    setColumns(columnArray);
                }
                setHasInitialized(true);
            }
        }
    }, [configurations]);

    useEffect(() => {
        if (!isEmpty(customAttributes['Client'])) {
            const tableConfiguration = configurations.find(item => item.viewKey === 'K2ACore|ClientTable');
            if (!isEmpty(tableConfiguration)) {
                if (!isEmpty(tableConfiguration.viewData.dataState.columns)) {
                    const colWidth = calculateMinColumnWidths(tableConfiguration.viewData.dataState.columns.filter(c => c.show), gridDivRef.current.offsetWidth, 'name', 450, true);
                    setClientNameColumnWidth(colWidth);
                    tableConfiguration.viewData.dataState.columns.find(c => c.id === 'clientColumn').width = colWidth;
                    setColumns(tableConfiguration.viewData.dataState.columns);
                }
                return;
            }

            const selectedAttributes = customAttributes['Client'];
            let updatedColumns = [...columns];
            selectedAttributes.forEach(item => {
                const attrColumn = columns.find(c => c.field === item.name);
                if (!attrColumn) {
                    updatedColumns.splice(1, 0, {
                        field:      item.name,
                        title:      startCase(item.name),
                        width:      200,
                        locked:     false,
                        sortable:   true,
                        filterable: true,
                        filter:     item.dataType || 'text',
                        show:       false,
                        hidden:     false,
                        orderIndex: updatedColumns.length - 1
                    });
                }
            });
            setColumns(updatedColumns);
        }
    }, [customAttributes]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            initialDataState.filter = initialDataStateFilter;

            setGridFilter(initialDataStateFilter);
            setGridFilterText('');

            const tableConfiguration = configurations.find(item => item.viewKey === 'K2ACore|ClientTable');
            if (!isEmpty(tableConfiguration)) {
                tableConfiguration.viewData.dataState.filter = initialDataStateFilter;
                setDataState(tableConfiguration.viewData.dataState);
            } else {
                setDataState(initialDataState);
            }

        }
        setColumns(columns.map(c => {
            c.filterable = c.actionCell ? false : workbookModeEnabled;
            return c;
        }));
    }, [workbookModeEnabled]);

    useEffect(() => {
        const init = async () => {
            await fetchCoreClients(activeNavCompany.id, { page: 1, limit: dataState.take });
        };

        const colWidth = calculateMinColumnWidths(defaultColumns.filter(c => c.show), gridDivRef.current.offsetWidth, 'name', 450, true);
        setClientNameColumnWidth(colWidth);
        defaultColumns.find(c => c.id === 'clientColumn').width = colWidth;
        setColumns(defaultColumns);


        if (activeNavCompany.id && (!clientsMeta.isActive || clientsMeta.company !== activeNavCompany.id)) init();
    }, [activeNavCompany]);

    useEffect(() => {
        if (tableProps.coreClient) {
            let updatedDataState = { ...dataState };
            updatedDataState.skip = (tableProps.coreClient.page * tableProps.coreClient.limit) - tableProps.coreClient.limit;
            updatedDataState.take = tableProps.coreClient.limit;
            setDataState(updatedDataState);
        }
    }, [tableProps]);

    useEffect(() => {
        setSelectedClients(clients);
    }, [clients]);

    useEffect(() => {
        setSelectedClients(clients.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase())));
    }, [searchTerm]);

    useEffect(() => {
        const refresh = async () => {
            setRefreshTab(view);
            await fetchCoreClients(activeNavCompany.id, { page: 1, limit: dataState.take });
            if (searchTerm) {
                setSelectedClients(clients.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase())));
            }
            setRefreshTab('');
        };

        if (refreshTab) refresh();
    }, [refreshTab]);

    const actionsCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <ClientContextMenu
                    dataItem={props.dataItem}
                    setCoreClient={setCoreClient}
                    setDeleteClientModalOpen={setDeleteClientModalOpen}
                    setSelectedClient={setSelectedClient}
                />
            </td>
        );
    };

    const handleDeleteClient = async () => {
        await deleteCoreClient(selectedClient.id);
        await fetchCoreClients(activeNavCompany.id, { page: 1, limit: dataState.take});
    };
    
    const handleNameNavigation = dataItem => {
        let path = '/v2/dashboard/core/entities';

        const queryValues = queryString.parse(history.location.search);
        queryValues.parentId = '3ee59a8f-d13a-475b-b424-ee55eef98a65';
        queryValues.childId= 'e979b520-3695-422d-a914-ba55c51fb316';
        queryValues.client = dataItem.id;

        const queryValuesString = queryString.stringify(queryValues);
        return (`${path}?${queryValuesString}`);
    };

    const handleNav = async dataItem => {
        let path = '/v2/dashboard/core/entities';

        const queryValues = queryString.parse(history.location.search);
        queryValues.parentId = '3ee59a8f-d13a-475b-b424-ee55eef98a65';
        queryValues.childId= 'e979b520-3695-422d-a914-ba55c51fb316';
        queryValues.client = dataItem.id;

        const client = {
            id:   dataItem.id,
            name: dataItem.name
        };

        setNavClient(client);
        setActiveNavClient(client);
        fetchNavSites(dataItem.id);

        const queryValuesString = queryString.stringify(queryValues);
        history.push(`${path}?${queryValuesString}`);
    };
    
    const nameCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <Link
                    to={handleNameNavigation(props.dataItem)}
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                handleNav(props.dataItem);
                            }
                        }
                    }
                >
                    {props.dataItem[props.field]}
                </Link>
            </td>
        );
    };

    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setDataState(e.dataState);
    };

    const onColumnReorder = async e => {
        const tempColumns = cloneDeep(columns).map(col => {
            const newCol = e.columns.find(c => c.field === col.field);
            if (newCol) {
                return {...col, orderIndex: newCol.orderIndex};
            }
            else {
                return col;
            }
        });

        setColumns(tempColumns);

        setHasInitialized(true);

        const tableConfiguration = configurations.find(item => item.viewKey === 'K2ACore|ClientTable');

        if (tableConfiguration) {
            dataState.columns = tempColumns;
            tableConfiguration.viewData = JSON.stringify({ dataState: dataState, ownerId: currentUser.id });
            await updateConfiguration(tableConfiguration.id, tableConfiguration, true);
            updateCoreConfigurations(tableConfiguration.id, tableConfiguration);
        } else {
            let body = {
                name:       'K2A Core Client Table Configuration',
                viewKey:    'K2ACore|ClientTable',
                entityId:   activeNavCompany.id,
                entityName: activeNavCompany.name,
                isDefault:  false,
                viewData:   JSON.stringify({ 
                    dataState: { 
                        ...dataState, 
                        columns: tempColumns 
                    }, 
                    ownerId: currentUser.id 
                }),
                sharedEmails: []
            };
            const id = await saveConfiguration(userId, body, true);
            if (id) {
                body.id = id;
                let activeState = cloneDeep(body.viewData);
                body.viewData = JSON.parse(activeState);
                updateCoreConfigurations(id, body);
            }
        }
    };

    const updateColumns = menuColumns => {
        const columnArray = menuColumns.map((c) => {
            const updatedColumn = menuColumns.find(mc => mc.field === c.field);
            
            if (updatedColumn) {
                c.orderIndex = updateColumns.orderIndex;
            }

            c.width = c.field === 'name' ? 450 : c.width;
            return c;
        });

        const colWidth = calculateMinColumnWidths(columnArray.filter(c => c.show), gridDivRef.current.offsetWidth, 'name', 450, true);
        setClientNameColumnWidth(colWidth);
        columnArray.find(c => c.id === 'clientColumn').width = colWidth;
        setColumns(columnArray);     

        const updatedDataState = { ...dataState };
        updatedDataState['columns'] = menuColumns;
        setDataState(updatedDataState);
    };

    const updateUserView = async (obj, formulaValues) => {
        const tableConfiguration = configurations.find(item => item.viewKey === 'K2ACore|ClientTable');
        if (tableConfiguration) {
            dataState.columns = columns;
            tableConfiguration.viewData = JSON.stringify({ 
                dataState: dataState, 
                ownerId:   currentUser.id 
            });
            await updateConfiguration(tableConfiguration.id, tableConfiguration, true);
            updateCoreConfigurations(tableConfiguration.id, tableConfiguration);
        } else {
            let body = {
                name:       'K2A Core Client Table Configuration',
                viewKey:    'K2ACore|ClientTable',
                entityId:   activeNavCompany.id,
                entityName: activeNavCompany.name,
                isDefault:  false,
                viewData:   JSON.stringify({ 
                    dataState: { 
                        ...dataState, 
                        columns: columns }, 
                    ownerId: currentUser.id 
                }),
                sharedEmails: []
            };
            const id = await saveConfiguration(userId, body, true);
            if (id) {
                body.id = id;
                let activeState = cloneDeep(body.viewData);
                body.viewData = JSON.parse(activeState);
                updateCoreConfigurations(id, body);
            }
        }
    };

    const clearGridFilter = filter => {
        setDataState({...dataState, filter: filter ? filter : initialDataStateFilter});
    };

    return (
        <React.Fragment>
            <style>
                {kendoGridInlineStyling}
                {
                    `.k-toolbar {
                            order: 1;
                            border-top: inset 1px rgba(0, 0, 0, 0.12);
                            max-height: 5.8rem;
                    }
                    `
                }
            </style>
            <div ref={gridDivRef} className={classes.Table}>
                <Grid
                    ref={gridRef}
                    sortable={{
                        mode: 'multiple'
                    }}
                    className={classes.KendoGrid}
                    data={kendoProcess(selectedClients, dataState)}
                    {...dataState}
                    onDataStateChange={onDataStateChange}
                    pageable={pageable}
                    reorderable
                    filterable={workbookModeEnabled}
                    onColumnReorder={onColumnReorder}
                >
                    {
                        workbookModeEnabled ?
                            <GridToolbar>
                                <FilterPanel
                                    title={'Client Filter Builder'}
                                    filter={dataState.filter}
                                    filterText={gridFilterText}
                                    fields={gridFields}
                                    columns={columns}
                                    setFilter={clearGridFilter}
                                    setFilterText={setGridFilterText}
                                />
                            </GridToolbar>
                            : null
                    }
                    {
                        <GridNoRecords>
                            Loading clients
                        </GridNoRecords>
                    }
                    {
                        orderBy(columns, 'orderIndex', 'asc').map((column, key) => column.show && (
                            <Column
                                field={column.field} title={column.title} key={key}
                                width={column.id === 'clientColumn' ? clientNameColumnWidth : column.width}
                                cell={column.field === '' ? actionsCell : column.field === 'name' ? nameCell : column.cell}
                                sortable={column.sortable}
                                filterable={column.filterable}
                                filter={column.filter}
                                locked={column.locked}
                                orderIndex={column.orderIndex}
                                columnMenu={column.field ?
                                    (props) => (
                                        <ColumnFilterMenu
                                            {...props}
                                            columns={columns}
                                            updateColumns={updateColumns}
                                            updateUserView={updateUserView}
                                            allowFiltering={false}
                                        />
                                    )
                                    :
                                    null
                                }
                            />
                        ))
                    }
                </Grid>
                {
                    deleteClientModalOpen ?
                        <DeleteCoreEntityModal
                            entity={{...selectedClient, type: 'Client'}}
                            handleDeleteEntity={handleDeleteClient}
                            toggleModalOpen={setDeleteClientModalOpen}
                        />
                        :
                        null
                }
                {
                    bobLoading.includes('FetchCoreClients') || isEmpty(clientsMeta) ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
    bobLoading:       state.bob.bobLoading,
    clients:          state.k2aCore.clients,
    clientsMeta:      state.k2aCore.clientsMeta,
    configurations:   state.configurationData.allConfigurations,
    currentUser:      state.currentUser,
    customAttributes: state.attributeManagement.customAttributes,
    userId:           state.currentUser.id,
    tableProps:       state.tableProps
});

const mapDispatchToProps = ({
    ...K2ACoreActions,
    ...TableActions,
    ...BobActions,
    ...ConfigurationActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CoreClientTable));
